// commonactions.jsx
import { Checkbox, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled Checkbox with custom colors
export const ColoredCheckbox = styled(Checkbox)(({ color }) => ({
  color: color || '#13a7b9',
  '&.Mui-checked': {
    color: color || '#13a7b9',
  },
  '&:hover': {
    backgroundColor: `${color || '#13a7b9'}15`,
  },
  '& .MuiSvgIcon-root': {
    fontSize: 20,
  },
}));

// Module Chip component for displaying module names with colors
export const ModuleChip = ({ moduleName }) => {
  const getModuleColor = (name) => {
    const colorMap = {
      'adminDashboard': '#673AB7',
      'dashboard': '#2196F3',
      'patient': '#4CAF50',
      'admissions': '#FF9800',
      'doctor': '#E91E63',
      'securityOfficer': '#795548',
      'staff': '#607D8B',
      'block': '#FF5722',
      'floor': '#9C27B0',
      'ward': '#3F51B5',
      'department': '#00BCD4',
      'specialization': '#CDDC39',
      'patientTransfer': '#FFC107',
      'adminTransfer': '#FF6F00',
      'history': '#8BC34A',
      'rolePermission': '#F44336',
      'adminProfile': '#9E9E9E',
      'staffProfile': '#00E676',
      'doctorProfile': '#FF1744',
      'staffPatientList': '#448AFF',
      'report': '#6200EA',
    };
    return colorMap[name] || '#13a7b9';
  };

  const formatModuleName = (name) => {
    // Convert camelCase to readable format
    return name
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .trim();
  };

  return (
    <Chip
      label={formatModuleName(moduleName)}
      size="small"
      sx={{
        backgroundColor: getModuleColor(moduleName),
        color: 'white',
        fontWeight: 'bold',
        fontSize: '0.75rem',
        '& .MuiChip-label': {
          padding: '0 8px',
        },
      }}
    />
  );
};